import { render, staticRenderFns } from "./VToast.vue?vue&type=template&id=645103fb&scoped=true&"
import script from "./VToast.vue?vue&type=script&lang=js&"
export * from "./VToast.vue?vue&type=script&lang=js&"
import style0 from "./VToast.vue?vue&type=style&index=0&id=645103fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645103fb",
  null
  
)

export default component.exports